import React, { useState } from 'react';
import './slideshow.css';

const Slideshow = ({ images }) => {
  const [current, setCurrent] = useState(0);
  const length = images.length;

  const nextSlide = () => {
    setCurrent(current === length - 1 ? 0 : current + 1);
  };

  const prevSlide = () => {
    setCurrent(current === 0 ? length - 1 : current - 1);
  };

  if (!Array.isArray(images) || images.length === 0) {
    return null;
  }

  return (
    <div className="slideshow">
      <button className="slide-btn left" onClick={prevSlide}>&#10094;</button>
      {images.map((img, idx) => (
        <div
          className={idx === current ? 'slide active' : 'slide'}
          key={idx}
        >
          {idx === current && (
            <img src={img} alt="Portal Screenshot" className="slide-image" />
          )}
        </div>
      ))}
      <button className="slide-btn right" onClick={nextSlide}>&#10095;</button>
    </div>
  );
};

export default Slideshow;
